import Vue from 'vue';

import PlayerBus from './modules/player';
import * as EVENT from './enum';

import { register, unregister } from './modules/heartbeat';
import timelineTagHighlight from './modules/timeline-tag-highlight';
import playerHotkeys from './modules/player-hotkeys';
import playerRestore from './modules/player-restore';

const _bus = new Vue();

const bus = {
	publish: (key, ...args) => {
		_bus.$emit(key, ...args);
	},
	subscribe: (key, handler) => {
		_bus.$on(key, handler);
	},
	once: (key, handler) => {
		_bus.$once(key, handler);
	},
	unsubscribe: (key, handler) => {
		_bus.$off(key, handler);
	},
};

// modules
const playerBus = new PlayerBus(bus);
const enableHeartbeat = () => {
	register(bus);
};

const disableHeartbeat = () => {
	unregister(bus);
};

const selfRegisterModules = [timelineTagHighlight, playerHotkeys, playerRestore];
for (const mod of selfRegisterModules) {
	mod(bus);
}

export default bus;
export { playerBus, EVENT, bus, enableHeartbeat, disableHeartbeat };
